import { FireScreenEventOnMountStateless } from 'util/analytics/fire-screen-event/fire-screen-event';
import { withScreenName } from 'util/analytics/screen-name-context';

const FireScreenEventOnMount = withScreenName(FireScreenEventOnMountStateless);

// Manually set the display name for sensible snapshots
FireScreenEventOnMount.displayName = 'FireScreenEventOnMount';

export { FireScreenEventOnMount };
